import React from 'react';
import { Switch, Tooltip } from '@knockrentals/knock-shared-web';
import TitleWithTooltip from './Components/TitleWithTooltip';
import {
  AI_RESIDENT_COLUMN_NAMES as COLUMN_NAMES,
  AI_RESIDENT_FIELDS as FIELDS,
  AI_RESIDENT_TOOL_TIPS as TOOL_TIPS,
} from './constants';

const getTooltip = (rowData) =>
  rowData.residentEnabled ? '' : 'AI Resident Product not active';

export const getAIResidentColumns = ({
  isResidentAiNurtureEnabled,
  renterAIResidentsEmailEnabledProperties,
  saveVaData,
}) => {
  const { properties: aiResidentEmailEnabledProperties = [] } =
    renterAIResidentsEmailEnabledProperties;

  const isAIResidentEmailColumnVisible =
    aiResidentEmailEnabledProperties.length > 0;
  const tableArray = [
    {
      title: 'Properties',
      width: '120px',
      field: 'propertyName',
      cellStyle: {
        position: 'sticky',
        left: 0,
        zIndex: 3,
        backgroundColor: '#fff',
      },
      headerStyle: {
        left: '0px',
        zIndex: 4,
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT]),
      tooltip: TOOL_TIPS[FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT],
      field: FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.resident_virtual_agent_chat}
                color="primary"
                disabled={!rowData.residentEnabled}
                name="resident-virtual-agent-chat"
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.RESIDENT_VIRTUAL_AGENT_SMS]),
      tooltip: TOOL_TIPS[FIELDS.RESIDENT_VIRTUAL_AGENT_SMS],
      field: FIELDS.RESIDENT_VIRTUAL_AGENT_SMS,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.resident_virtual_agent_sms}
                color="primary"
                disabled={!rowData.residentEnabled}
                name="resident-virtual-agent-sms"
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.RESIDENT_VIRTUAL_AGENT_SMS,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: TitleWithTooltip(
        COLUMN_NAMES[FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE],
      ),
      tooltip: TOOL_TIPS[FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE],
      field: FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.resident_virtual_agent_voice}
                color="primary"
                disabled={!rowData.residentEnabled}
                name="resident-virtual-agent-voice"
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
  ];

  if (isAIResidentEmailColumnVisible) {
    tableArray.push({
      title: TitleWithTooltip(
        COLUMN_NAMES[FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL],
      ),
      tooltip: TOOL_TIPS[FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL],
      field: FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                aria-label={`resident-email-switch-${rowData.property_id}`}
                checked={!!rowData.resident_virtual_agent_email}
                color="primary"
                disabled={!rowData.residentEnabled}
                name="resident-virtual-agent-email"
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    });
  }
  if (isResidentAiNurtureEnabled) {
    tableArray.push({
      title: TitleWithTooltip(
        COLUMN_NAMES[FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED],
      ),
      tooltip: TOOL_TIPS[FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED],
      field: FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED,
      width: '100px',
      render: (rowData) => (
        <Tooltip title={getTooltip(rowData)}>
          <span>
            <Switch
              checked={!!rowData.is_resident_ai_nurture_enabled}
              color="primary"
              disabled={!rowData.residentEnabled}
              onChange={(event) =>
                saveVaData(
                  rowData,
                  FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED,
                  event.target.checked,
                )
              }
            />
          </span>
        </Tooltip>
      ),
    });
  }
  return tableArray;
};
